import {
  BodyText,
  Button,
  Heading,
  Icon,
  IconSet,
} from '@postscript/components';

import { useGlobalModal } from 'components/GlobalModal/globalModal';
import { useUser } from 'controllers/contexts/user';

import ShopperLearnMoreModal from 'components/shopper/components/modals/ShopperLearnMoreModal';

import {
  PROGRESSIVE_ONBOARDING_SOURCE,
  SHOPPER_FEATURE_KEY,
} from 'providers/ProgressiveOnboarding/constants/constants';
import { logButtonClickEvent, PRODUCT_AREAS } from 'utils/events';

import classes from 'components/ProgressiveOnboarding/ProgressSplashScreen.module.css';

const SelectionCard = ({
  icon,
  title,
  description,
}: {
  icon: keyof typeof IconSet;
  title: string;
  description: string;
}) => {
  return (
    <div className={classes.selectionCard}>
      <Icon component={IconSet[icon]} color="var(--blue-core)" />

      <div className={classes.text}>
        <Heading size="xx-small">{title}</Heading>

        <BodyText size="small">{description}</BodyText>
      </div>
    </div>
  );
};

export const ProgressSplashscreen = ({ dismiss }: { dismiss: () => void }) => {
  const { user } = useUser();
  const { showModal } = useGlobalModal();

  const onClickLearnMore = (event: React.MouseEvent<HTMLButtonElement>) => {
    showModal({
      children: <ShopperLearnMoreModal />,
      style: { width: 1130, padding: 0 },
    });

    logButtonClickEvent(event, {
      productArea: PRODUCT_AREAS.SHOPPER,
      source: PROGRESSIVE_ONBOARDING_SOURCE,
      workflow: SHOPPER_FEATURE_KEY,
      shop_id: user.shop_id,
    });
  };

  return (
    <div className={classes.splashScreen}>
      <div className={classes.header}>
        <div className={classes.featureTag}>
          <Heading size="medium" color="var(--text-color-inverse)">
            Shopper
          </Heading>
        </div>

        <Heading size="medium" className={classes.title}>
          Your brand&apos;s always-on AI shopping assistant
        </Heading>
      </div>

      <div className={classes.body}>
        <SelectionCard
          icon="TrendingUp"
          title="Drive More Conversions"
          description="Target subscribers who haven't converted and help them shop."
        />

        <SelectionCard
          icon="TwoWayConvo"
          title="24/7 Coverage, 1-Min Responses"
          description="Save time for your CX team while ensuring your customers get the attention they deserve. Subject to quiet hours restrictions."
        />

        <SelectionCard
          icon="Users"
          title="Valuable Insights"
          description="Learn from your customers and improve your marketing strategy with actionable insights."
        />
      </div>

      <div className={classes.footer}>
        <Button variant="plain" onClick={onClickLearnMore}>
          Learn More
        </Button>
        <Button variant="primary" onClick={dismiss}>
          Set Up Shopper
        </Button>
      </div>
    </div>
  );
};
